import { isSome } from '@mbfab/shared'
import { z } from 'zod'

import { APP_LOCAL_STORAGE_KEYS } from '../local-storage-keys'

const userInfoSchema = z.object({
  email: z.string(),
  id: z.string(),
  name: z.string(),
  tenant: z.object({ id: z.string(), name: z.string() }),
})

export type MonitoringUserInfo = z.infer<typeof userInfoSchema>

export function getMonitoringUserInfo(): MonitoringUserInfo | undefined {
  try {
    const cached = localStorage.getItem(APP_LOCAL_STORAGE_KEYS.userInfoForLog)
    return isSome(cached) ? userInfoSchema.parse(JSON.parse(cached)) : undefined
  } catch {
    return undefined
  }
}

export function setMonitoringUserInfo(user: MonitoringUserInfo): void {
  localStorage.setItem(APP_LOCAL_STORAGE_KEYS.userInfoForLog, JSON.stringify(userInfoSchema.parse(user)))
}
